// extracted by mini-css-extract-plugin
export var actions = "_m8-5";
export var assistantBubble = "_m8-3";
export var assistantRow = "_m8-6";
export var bubble = "_m8-0";
export var humanAvatar = "_m8-4";
export var inlineToolCard = "_m8-1";
export var userBubble = "_m8-2";